import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { FlowDefinitionTemplateVisibility } from 'flow-schema';
import { useId } from 'react';

import { Text } from 'common';

import { FlowTemplateFilterGroup, type FlowTemplateFilterGroupState } from './FilterGroup';
import { FLOW_TEMPLATE_VISIBILITY_LABELS } from '../utils';

interface FlowTemplateVisibilityFilterProps {
  visibilities: FlowDefinitionTemplateVisibility[];
  onChangeVisibility: (visibilities: FlowDefinitionTemplateVisibility[]) => void;
  sectionState: FlowTemplateFilterGroupState;
  onSectionStateChange: (state: FlowTemplateFilterGroupState) => void;
}

export function FlowTemplateVisibilityFilter(props: FlowTemplateVisibilityFilterProps) {
  const { visibilities, onChangeVisibility, sectionState, onSectionStateChange } = props;
  const fieldId = useId();

  return (
    <FlowTemplateFilterGroup
      label="Access Level"
      state={sectionState}
      onStateChange={onSectionStateChange}
    >
      <RadioGroup
        id={fieldId}
        name="flow-template-visibility-filter"
        value={visibilities[0] ?? ''}
        onChange={(event) => {
          onChangeVisibility([event.target.value as FlowDefinitionTemplateVisibility]);
        }}
      >
        {Object.values(FlowDefinitionTemplateVisibility).map((visibility) => {
          return (
            <FormControlLabel
              key={visibility}
              value={visibility}
              control={<Radio size="small" />}
              label={<Text variant="body2">{FLOW_TEMPLATE_VISIBILITY_LABELS[visibility]}</Text>}
            />
          );
        })}
      </RadioGroup>
    </FlowTemplateFilterGroup>
  );
}
